import styled from 'styled-components';
import { fontFamilySize, px } from '../../../../../../contrib/ui';

export const StyledContestSetupTable = styled.div`
  width: 100%;

  .contest-selector-table {
    &-container {
      width: 100%;
      margin-bottom: ${px(15)};
      padding: 0;

      &-table {
        min-width: ${px(250)};
        thead {
          tr {
            height: calc(var(--apx) * 50);
            background-image: linear-gradient(black, #444);

            th {
              ${fontFamilySize('Bold', 16)}
              color: white;
              text-transform: uppercase;

              .select-all-checkbox {
                color: white !important;
              }
            }
          }
        }

        tbody {
          tr {
            td,
            th {
              ${fontFamilySize('Bold', 16)}

              color: var(--dark);

              background-image: linear-gradient(95deg, #ededed 38%, #ffffff 63%);
              background-size: cover;
              background-position: center;
              background-attachment: fixed;
            }
          }
        }
      }
    }
  }
`;
